<template>
  <v-btn color="success"
         small
         outline
         :href="fileUrl"
         target="_blank"
         v-if="showDownloadBtn"
         >
         {{ $t('download') }}
  </v-btn>
</template>

<script>
export default {
  name: 'ShipmentDownloadBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
    fileUrl () {
      if (!this.shipment) { return '' }
      if (!this.shipment.generated_label) { return '' }
      if (!this.shipment.generated_label.file) { return '' }
      if (!this.shipment.generated_label.file.url) { return '' }
      return this.shipment.generated_label.file.url
    },

    showDownloadBtn () {
      return this.shipment.step === 'confirmed' &&
        (this.shipment.status === 'success' || (this.shipment.status === 'canceled' && this.$auth.isDev())) &&
        !!this.shipment.generated_label
    }
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
